import { AnyAction } from "redux"
import {
  CARDS_FETCH_CALL,
  CARDS_FETCH_FAILURE,
  CARDS_FETCH_SUCCESS,
  CHARTS_FETCH_CALL,
  CHARTS_FETCH_SUCCESS,
  PRODUCT_FETCH_CALL,
  PRODUCT_FETCH_FAILURE,
  PRODUCT_FETCH_SUCCESS
} from "./metrics-types"

const initialSummary: App.MetricsSummary = {
  total: 0,
  variation: 0,
  difference: 0
}

const INITIAL_STATE: App.MetricsState = {
  productsPerfomance: {
    products: [],
    totalItems: 0,
    loading: false,
    error: ""
  },
  charts: {
    data: {
      netBalance: {
        dailyResults: [],
        summary: initialSummary
      },
      newAccounts: {
        dailyResults: [],
        summary: initialSummary
      },
      events: {
        dailyResults: [],
        summary: initialSummary
      }
    },
    loading: false,
    error: ""
  },
  cards: {
    data: {
      netBalance: {
        result: initialSummary
      },
      averageConsumption: {
        result: initialSummary
      },
      totalEvents: {
        result: initialSummary
      }
    },
    loading: false,
    error: ""
  }
}

export default function metricsReducer(state: App.MetricsState = INITIAL_STATE, action: AnyAction) {
  switch (action.type) {
    case PRODUCT_FETCH_CALL:
      return {
        ...state,
        productsPerfomance: {
          ...state.productsPerfomance,
          loading: true,
          error: ""
        }
      }

    case PRODUCT_FETCH_SUCCESS:
      return {
        ...state,
        productsPerfomance: {
          products: action.payload.data.products as App.ProductPerfomance[],
          totalItems: action.payload.data.totalItems as number,
          loading: false,
          error: ""
        }
      }

    case PRODUCT_FETCH_FAILURE:
      return {
        ...state,
        productsPerfomance: {
          ...state.productsPerfomance,
          loading: false,
          error: action.payload as string
        }
      }

    case CHARTS_FETCH_CALL:
      return {
        ...state,
        charts: {
          ...state.charts,
          loading: true,
          error: ""
        }
      }

    case CHARTS_FETCH_SUCCESS:
      return {
        ...state,
        charts: {
          data: action.payload.data as App.MetricsState["charts"]["data"],
          loading: false,
          error: ""
        }
      }

    case CARDS_FETCH_CALL:
      return {
        ...state,
        cards: {
          ...state.cards,
          loading: true,
          error: ""
        }
      }

    case CARDS_FETCH_FAILURE:
      return {
        ...state,
        cards: {
          ...state.cards,
          loading: false,
          error: action.payload as string
        }
      }

    case CARDS_FETCH_SUCCESS:
      return {
        ...state,
        cards: {
          data: action.payload.data as App.MetricsState["cards"]["data"],
          loading: false,
          error: ""
        }
      }

    default:
      return state
  }
}
